var React = require('react');

function KbdSpace (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 11L16 16 0 16 0 11 1.167 11 1.167 13.904 14.833 13.904 14.833 11z"}));
}

KbdSpace.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdSpace;

KbdSpace.default = KbdSpace;
